module.exports = __webpack_public_path__ + "static/media/walltittle2.05eb5e96.jpeg";